import { Canvas } from "@react-three/fiber";
import { Environment } from "@react-three/drei";
import CakeModel from "./CakeModel";

export default function CakeCanvas() {
  return (
    <Canvas
      camera={{ position: [0, 0, 3.2], fov: 35 }}
      style={{ width: "100%", height: "100%" }}
    >
      <ambientLight intensity={1.3} />
      <directionalLight position={[6, 6, 6]} intensity={2.2} />
      <directionalLight position={[-4, 3, -4]} intensity={1.2} />

      <CakeModel />

      <Environment preset="studio" />
    </Canvas>
  );
}
